module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "button-style": _vm.scheme.colour,
      "heading": 'Request to ' + _vm.scheme.text,
      "show-text": _vm.showText,
      "size": this.adding ? 'small' : 'default',
      "button-type": _vm.buttonType,
      "button-text": _vm.scheme.text,
      "center-button": true,
      "round": _vm.round,
      "show-save": _vm.adding,
      "bg-class": _vm.formatBG,
      "button-icon": _vm.scheme.icon,
      "disableButton": (_vm.isTowerCo() && !_vm.isManager('project|finance|admin')) || _vm.isViewOnly()
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [(_vm.type === 'RTA') ? _c('section', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.adding) ? _c('acquire-request', {
    ref: "ad",
    attrs: {
      "client-id": this.orgId
    }
  }) : _c('acquire-details', {
    ref: "ad",
    attrs: {
      "row-data": _vm.rowData
    }
  })], 1)], 1)], 1) : _c('section', [(_vm.adding) ? _c('action-details', {
    ref: "ad",
    attrs: {
      "site-id": _vm.siteId,
      "row-data": _vm.rowData,
      "editMode": true,
      "type": _vm.type,
      "adding": true,
      "hide-panel": true,
      "table-ref": _vm.tref
    }
  }) : _c('request-details', {
    attrs: {
      "row-data": _vm.rowData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9bb4ccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/RequestAction.vue
// module id = 1720
// module chunks = 0